import React from 'react'
// import { useState } from 'react'
import NigerianBanksData from './nigerianbanks'
import { CurrencyManager } from '../../../services/currency'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';


const currencyManager = new CurrencyManager();

export default class AddCard extends React.Component{
    initialState = {
        accountCurrency: null,
        recipientCountry: null,
        recipientBank: '',
        bankNumber: '',
        accountName: '',
        city: '',
        firstInput: false,
        secondInput: false,
        banksData: NigerianBanksData,
        allCurrency: [],

    }

    state = this.initialState


    handleChange = (event) => {
        const {name, value} = event.target 

        this.setState({
            [name]: value,
        })
    }

    handleDetailsChange = (event) => {
        this.setState({
            accountCurrency: event.target.value
        })
    }

    handleCurrencyChange = (event) => {
        this.setState({
            recipientCountry: event.target.value
        })
    }

    submitForm = (event) =>{
        event.preventDefault()
        const {banksData, ...data } = this.state
        let validate = false
        console.log(data)
        // fake validation
        for (const item of Object.values(data)){
            validate = item !== ''
            if(!validate) { break }
        }

        // block submit on empty values 
        if(validate){
           
            this.props.handleClose()
            this.props.handleClickOpen()
            this.props.handleSubmit(this.state)
            this.props.handleAccountLoader()
            
        }

        this.setState(this.initialState)
    }
    
    // handleDisplay(name) {
    //     switch(name){
    //         case 'firstInput':
    //         this.setState({ firstInput: !this.state.firstInput})
    //         break;
    //         case 'secondInput':
    //         this.setState({ secondInput: !this.state.secondInput})
    //         break;
    //         default: 
    //         return null
    //     }
    // }

    componentDidMount () {
        currencyManager.getAllCurrencies(res => {
            
            //updating loader state
            this.setState({
                loader: true
            })

            //updating currency state
            try {
                this.setState ( {
                    allCurrency: res
                    })

            //updating loader state
                this.setState({
                    loader: false
                })
            }catch(err) {
                console.log(err)

                //updating loader state
                this.setState({
                    loader: false
                })
            }
            
        })
     
       
    }

    render(){
        const { accountCurrency, recipientCountry, bankNumber, recipientBank, accountName, city} = this.state
        const banksData = this.state.banksData.map((data) => {
            return(
                <option value={data.name}>{data.name}</option>
            )
        })
        console.log(this.state.accountCurrency)
        console.log(this.state.recipientCountry)
        console.log(this.props.accountLoader + "me")

    //     console.log(this.state.allCurrency)
    //     console.log(this.state.loader)
    //   console.log("this is loader state " + this.state.loaderState)
        return(
            <form onSubmit={this.submitForm}>
                {this.state.loader ? <Box sx={{textAlign: "center"}}><CircularProgress size={30} /></Box> :  <div className="form-group">
                    <label htmlFor="accountCurrency">Account Currency</label>
                    <select 
                           className="form-control" 
                           type="text"
                           name="accountCurrency" 
                           id="accountCurrency"
                           value={accountCurrency}
                           onChange={(value) =>
                               {
                                   this.handleChange(value)
                                   this.handleDetailsChange()
                               }
                           }
                       >
                           
                           <option selected>--Select account currency--</option>
                           {this.state.allCurrency.map((item, index) => (
                           <option value={item.id}>{item.name}</option>
                           ))}
                       </select>
                    
                    
                    <label htmlFor="recipientCountry">Recipient Account Country</label>
                    <select 
                        className="form-control" 
                        type="text"
                        name="recipientCountry" 
                        id="recipientCountry"
                        value={recipientCountry}
                        onChange={(value) =>
                            {
                                this.handleChange(value)
                                this.handleCurrencyChange()
                            }
                        }
                    >
                        <option selected>--Select account currency--</option>
                        <option value="Nigeria">Nigeria</option>
                    </select>
                </div>}
                
                
                {accountCurrency && recipientCountry &&(
                    <div className="form-group">
                                <label htmlFor="bankNumber">Bank Account Number</label>
                                <input 
                                    className="form-control" 
                                    type="number"
                                    name="bankNumber"
                                    id="bankNumber" 
                                    value={bankNumber}
                                    onChange={(value) =>
                                        {
                                            this.handleChange(value)
                                        }
                                    }
                                    required="required"
                                />

                                <label htmlFor="bankNumber">Account Name</label>
                                <input 
                                    className="form-control" 
                                    type="text"
                                    name="accountName"
                                    id="accountName" 
                                    value={accountName}
                                    onChange={(value) =>
                                        {
                                            this.handleChange(value)
                                        }
                                    }
                                    required="required"
                                />

                                
                                <label htmlFor="bankNumber">Fill in your city</label>
                                <input 
                                    className="form-control" 
                                    type="text"
                                    name="city"
                                    id="city" 
                                    value={city}
                                    onChange={(value) =>
                                        {
                                            this.handleChange(value)
                                        }
                                    }
                                    required="required"
                                />
                            
                            <label htmlFor="recipientBank">Recipient Account Bank</label>
                            <select 
                                className="form-control" 
                                type="text"
                                name="recipientBank" 
                                id="recipientBank"
                                value={recipientBank}
                                onChange={(value) =>
                                    {
                                        this.handleChange(value)
                                    }
                                }
                                required="required"
                            >
                                <option value="">--Select Recipient account Bank--</option>
                                {banksData}
                            </select>
                            
                            <input className="btn btn-primary mt-3" type="submit" value="Add Bank Account"
                            //  onClick={() =>{
                            //     this.submitForm()
                            //     this.handleClickOpen()
                               
                                
                            // }
                            //     }

                                />
                           
                    </div>
                )}
            </form>
        )
    }
   
}
